import DateDisplay from 'components/DateDisplay';
import { FaultRow } from 'components/tables/data/fault/types';

/**
 * Column for the fixed at.
 */
export default function FixedAtColumn({ data: { fixed } }: { data: FaultRow }) {
  return fixed?.fixedAt ? <DateDisplay date={new Date(fixed?.fixedAt)} /> : '';
}
